var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('div',{staticClass:"readonly"},[(_vm.title && _vm.value)?_c('span',{staticClass:"readonly__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"readonly__content"},[_vm._t("before"),(_vm.getValue)?_c('span',{staticClass:"readonly__description",class:{
          'readonly__description__break-all' : _vm.breakAll,
          'readonly__description__hide-after' : _vm.hideAfter,
        }},[_vm._v(" "+_vm._s(_vm.getValue)+" ")]):_vm._e()],2)]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }